// (C) Copyright 2025 Hewlett Packard Enterprise Development LP
import { useContext } from 'react'
import {
  AppsRounded,
  Certificate,
  DocumentVideo,
  ServerCluster,
  UserAdd,
  UserAdmin
} from 'grommet-icons'
import { useFlags } from 'launchdarkly-react-client-sdk'
import { ThemeContext } from 'grommet'

import { isGLOP, isTenant } from '../../../utils/feature-flag-utils'

const GettingStartedCardData = () => {
  const LDFlags = useFlags()
  const { global } = useContext(ThemeContext)
  const data = isGLOP()
    ? [
        {
          anchor: '/system/certificates',
          description: 'dashboard:dashboard.manage_certificates.description',
          icon: <Certificate color="#7630EA" size="xxlarge" />,
          title: 'dashboard:dashboard.manage_certificates.title',
          rbac: {
            resource: '/ccs/system-mgmt/certificates',
            permission: 'ccs.system-mgmt.certificates.read'
          }
        },
        {
          anchor: '/home',
          description: 'dashboard:dashboard.import_resources.description',
          icon: <ServerCluster color={global.colors.orange} size="xxlarge" />,
          title: 'dashboard:dashboard.import_resources.title',
          hideFor: { account: ['TENANT'] },
          rbac: {
            resource: '/ccs/device-management',
            permission: 'ccs.device-management.edit'
          }
        },
        {
          anchor: '/manage-account/identity/users',
          description: 'dashboard:dashboard.manage_users.description',
          icon: <UserAdd color={global.colors.red.dark} size="xxlarge" />,
          title: 'dashboard:dashboard.manage_users.title'
        },
        {
          anchor: '/manage-account/identity/roles',
          description: 'dashboard:dashboard.manage_roles.description',
          icon: <UserAdmin color={global.colors.blue.dark} size="xxlarge" />,
          title: 'dashboard:dashboard.manage_roles.title'
        }
      ]
    : [
        ...(!isTenant()
          ? [
              {
                anchor: '/services/service-catalog',
                description: 'dashboard:dashboard.find_services.description',
                icon: (
                  <AppsRounded
                    size="xxlarge"
                    color={global.colors.green.dark}
                  />
                ),
                title: 'dashboard:dashboard.find_services.title',
                hideFor: { account: ['TENANT'] }
              }
            ]
          : []),
        {
          anchor: '/manage-account',
          description: 'dashboard:dashboard.manage_workspace.description',
          icon: <UserAdd color="purple" size="xxlarge" />,
          title: 'dashboard:dashboard.manage_workspace.title'
        },
        ...(LDFlags['glcp-videos-tutorial']
          ? [
              {
                anchor: '/home/videos-tutorials',
                description:
                  'common:get_started_videos_tutorials.dashboard.description',
                icon: <DocumentVideo color="blue" size="xxlarge" />,
                title: 'common:get_started_videos_tutorials.dashboard.title',
                hideFor: {
                  feature: 'glcp-videos-tutorial'
                }
              }
            ]
          : [])
      ]

  return data
}

export { GettingStartedCardData }
